import { Injectable } from '@angular/core';
import { AndroidSettings, IOSSettings, NativeSettings } from 'capacitor-native-settings';

@Injectable({
  providedIn: 'root',
})
export class DeviceService {
  public openAppSettings$(): Promise<{ status: boolean }> {
    return NativeSettings.open({
      optionAndroid: AndroidSettings.ApplicationDetails,
      optionIOS: IOSSettings.App,
    });
  }

  /** Opens the OS WiFi settings screen (Android: wireless settings, iOS: WLAN). */
  public openWifiSettings$(): Promise<{ status: boolean }> {
    return NativeSettings.open({
      optionAndroid: AndroidSettings.Wireless,
      optionIOS: IOSSettings.WiFi,
    });
  }
}
